import type { TOC } from '@ember/component/template-only';
import fuiAccordion from 'wise-fui-modules/modifiers/fui-accordion';

export default <template>
  <div {{fuiAccordion}} class='ui accordion' ...attributes>
    <div class='{{if @isActive "active"}} title'>
      <h3 class='ui dividing header mb16'>
        {{@title}}
        <div class='float-right'>
          <i data-test-expand-accordion={{@title}} class='dropdown icon'></i>
        </div>
      </h3>
    </div>

    <div class='{{if @isActive "active"}} content mb16'>
      {{yield}}
    </div>
  </div>
</template> satisfies TOC<{
  Element: HTMLDivElement;
  Args: {
    title: string;
    isActive?: boolean;
  };
  Blocks: {
    default: [];
  };
}>;
